<template>
    <button
        v-bind="$attrs"
        class="flex items-center justify-center w-full min-w-[120px] px-6 py-3.5 
               border-none rounded-xl bg-a-blue-0064ff text-white
               font-medium text-16 leading-6 text-center cursor-pointer
               transition-all duration-200 ease-in-out
               hover:bg-blue-700 active:bg-blue-800 active:scale-[0.98]
               disabled:bg-a-gray-c4c4c4 disabled:cursor-not-allowed"
        :class="[sizeClass, { 'cursor-wait': loading }]"
        :disabled="disabled || loading"
        @click="handleClick"
    >
        <span v-if="loading" class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
        <span v-else class="flex items-center justify-center gap-2">
            <slot>{{ text }}</slot>
        </span>
    </button>
</template>

<script>
export default {
    name: "PrimaryButton",
    emits: ['click'],
    props: {
        // Button text (can also use slot)
        text: {
            type: String,
            default: ''
        },
        // Button size: 'small', 'medium', 'large'
        size: {
            type: String,
            default: 'large'
        },
        // Disabled state
        disabled: {
            type: Boolean,
            default: false
        },
        // Loading state
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        sizeClass() {
            const sizes = {
                small: 'py-2 px-4 text-14 leading-5 min-w-[80px]',
                medium: 'py-3 px-5 text-14 leading-5 min-w-[100px]',
                large: 'py-3.5 px-6 text-16 leading-6 min-w-[120px]'
            };
            return sizes[this.size] || sizes.large;
        }
    },
    methods: {
        handleClick(event) {
            if (!this.disabled && !this.loading) {
                this.$emit('click', event);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
